export default {
  number: {
    value: 1,
    name: '次卡',
    tip: '限制使用时间和次数',
  },
  time: {
    value: 2,
    name: '期限卡',
    tip: '仅限制使用时间',
  },
};
